var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSearchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.8337V8.88108C16.6667 8.19978 16.6667 7.85916 16.5398 7.55288C16.4129 7.24659 16.1721 7.00573 15.6903 6.52402L11.7433 2.57689C11.3275 2.16116 11.1197 1.95328 10.8621 1.83012C10.8085 1.80449 10.7537 1.78176 10.6977 1.762C10.4284 1.66699 10.1345 1.66699 9.54651 1.66699C6.84236 1.66699 5.49027 1.66699 4.57445 2.40538C4.38943 2.55456 4.22091 2.72308 4.07173 2.9081C3.33334 3.82392 3.33334 5.17601 3.33334 7.88019V11.667C3.33334 14.8097 3.33334 16.3811 4.30965 17.3573C5.19557 18.2432 6.57143 18.3253 9.16668 18.3329M10.8333 2.08366V2.50033C10.8333 4.85735 10.8333 6.03586 11.5656 6.76809C12.2978 7.50033 13.4763 7.50033 15.8333 7.50033H16.25",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.3337L14.8774 16.5444M14.8774 16.5444C14.9729 16.449 15.0616 16.3468 15.1428 16.2387C15.5017 15.7612 15.7142 15.1675 15.7142 14.5242C15.7142 12.9462 14.4351 11.667 12.8572 11.667C11.2792 11.667 10 12.9462 10 14.5242C10 16.1021 11.2792 17.3812 12.8572 17.3812C13.6461 17.3812 14.3604 17.0615 14.8774 16.5444Z",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearchActive);
export default __webpack_public_path__ + "static/media/file-search-active.8809745d521d6ba118330aeba9b63d91.svg";
export { ForwardRef as ReactComponent };